// extracted by mini-css-extract-plugin
var _1 = "Urnyw";
var _2 = "f3CvT";
export { _1 as "base", _2 as "overview" }
